import { DbListBase } from "./db-list-base";
//import { DbObjectBase } from "./db-object-base";
import { ICollectionReference } from '../database-cast/IDatabase';
// import { Customer } from '../../../core/_shared/models/Customer';
// import { DbCustomer } from './db-customer';
// import { Method } from '../../../core/_shared/models/Method';
// import { DbMethod } from './db-method';
import { MethodTask } from '../../../core/_shared/models/method-task';
// import { DbTable } from './db-table';
// import { DbCustomerTask } from './db-customer-tasks';


export class DbMethodTasks extends DbListBase<MethodTask> {

  
  constructor(collection: ICollectionReference) {
      super(collection);
  }
   
  
}


